import React, { useEffect, useState } from 'react'
import { checkApiStatus } from '../../../../utils';
import { globalBetaGetService } from '../../../../utils/globalApiServices';
import { AccordionDetails, Typography, Box, Paper, Grid, Card } from '@mui/material';
import moment from 'moment';
import { getWhatsNewApi } from '../apiServices';
import { PageLoader } from '../../../../shared_elements';
const WhatsNew = () => {
    const [whatsNewInfo,setWhatsNewInfo]=useState()
    const [isLoading, setLoading] = useState(false);
   

     useEffect(() => {
      getWhatsNewList('fetch', { per_page: 20 });
     }, []);
      
     const getWhatsNewList = (loaderType, query = {}) => {
       setLoading(true);
        globalBetaGetService(getWhatsNewApi({application:1,timestamp: Date.now()})).then(response => {
         if (checkApiStatus(response)) {
         setLoading(false);
         setWhatsNewInfo(response.data.data);
             } else {
           setLoading(false);
         }
       })
    };

  return (
    <>
     <Card sx={{padding:"5px 5px 5px 5px"}}>
      <Grid container spacing={2} alignItems={"center"}>
        <Grid size={{ md: 6, xs: 12 }}>
         <Typography color='primary' fontSize={"20px"}>What's New</Typography>
            </Grid>
          <Grid size={{ md: 6, xs: 12 }}  sx={{ display:"flex",justifyContent:"flex-end"}}>
        </Grid>
      </Grid>
    </Card>
       <Box style={{ margin: '20px 0px 0px 0px' }}>
         <Paper
           className='lease-details-section'
           style={{  height: `${window.innerHeight - 180}px`,  overflowY: 'auto',  marginTop: '10px'}}
          >
         {
             whatsNewInfo?.length > 0 ? 
             whatsNewInfo.map((item, index) => (
            <Box key={index} sx={{ marginBottom: "20px" }}>
            <Card>
              <Box sx={{ padding: "0px 0px 0px 8px" }}>
                <Typography fontSize={"10px"} mt={"15px"}>
                  {moment(item.release_date).format("MMM DD, YYYY")}
                </Typography>
                <Typography color='primary' variant="h5" gutterBottom fontSize={"16px"} margin={"20px 0px 0px 0px"}>
                  {item.title}
                </Typography>
              </Box>
              <AccordionDetails sx={{ padding: "10px" }}>
                <Typography
                  component="div"
                  sx={{ padding: 0, fontSize: "13px" }}
                  dangerouslySetInnerHTML={{ __html: item.description }}
                />
              </AccordionDetails>
            </Card>
          </Box>
        ))
      : 
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
          <Typography>No records found</Typography>
        </Box>
    }
  </Paper>
</Box>
      {isLoading ? <PageLoader /> : null}

    </>
  )
}

export default WhatsNew